var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "145px",
    height: "145px",
    viewBox: "0 0 705.651 705.65",
    xmlSpace: "preserve",
    transform: "rotate(0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 2.8226039999999997
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "604.901,279.15 426.5,100.65 426.5,100.65 36.701,490.551 215.1,668.95 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8,691.95l145.601,13.7l-1.301-1.3L1.3,528.551L0,527.25l13.7,145.601C14.5,681.45,24.201,691.15,32.8,691.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.6,242.45L463.201,63.95l58.1-58.1c7.8-7.801,20.5-7.801,28.3,0L699.8,156.05c7.8,7.801,7.8,20.5,0,28.301 L641.6,242.45z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenSvg);
export default __webpack_public_path__ + "static/media/penSvg.de62c8d0586ecfc45af63aa3afac6533.svg";
export { ForwardRef as ReactComponent };